import React from "react";
import { SubSection } from "context/BlogContext";

interface PreviewCodeProps {
  subSection: SubSection;
}

const PreviewCode: React.FC<PreviewCodeProps> = ({ subSection }) => {
  return (
    <div>
      {subSection.type === "code" && (
        <div className="pt-5">
          {subSection.title && <h6 className="text-15 mb-2">{subSection.title}</h6>}
          {/* <p className="pt-2 capitalize">{subSection.attrs?.language}</p> */}
          <pre className="" style={{ backgroundColor: "#e1e1e1", color: "#000", padding: "20px", borderRadius: "5px", overflowX: "auto" }}>
            <code className="">{subSection.attrs?.code}</code>
          </pre>
          {/* <pre className="bg-gray-900 text-white p-4 rounded-lg text-sm overflow-x-auto">
            <code className="whitespace-pre">{subSection.attrs?.code}</code>
          </pre> */}
        </div>
      )}
    </div>
  );
};

export default PreviewCode;
